import { render, staticRenderFns } from "./tagging.vue?vue&type=template&id=acfd6698&scoped=true"
import script from "./tagging.vue?vue&type=script&lang=js"
export * from "./tagging.vue?vue&type=script&lang=js"
import style0 from "./tagging.vue?vue&type=style&index=0&id=acfd6698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfd6698",
  null
  
)

export default component.exports